import React from 'react';

import QuestionLabel from './Components/QuestionLabel';
import Options from './Components/Options';
import ChoiceType from './Components/ChoiceType';

export default function OpenChoiceProperties({ question }) {
  return <>
    <QuestionLabel question={question} />

    <Options question={question} />

    <ChoiceType question={question} />
  </>
};